module.exports = {
      id: "step-3-usage",
      viewBox: "0 0 86 85",
      url: __webpack_public_path__ + "img/icons.91580017.svg#step-3-usage",
      toString: function () {
        return this.url;
      }
    }